import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

export default function HubLayout() {
  const nav = useNavigate();
  const user = JSON.parse(localStorage.getItem('sdx_user') || '{}');

  const logout = () => {
    localStorage.removeItem('sdx_token');
    localStorage.removeItem('sdx_user');
    nav('/login');
  };

  const linkStyle = ({ isActive }) => ({
    display: 'block', padding: '10px 16px', color: isActive ? '#fff' : '#d1d5db',
    background: isActive ? '#7f1d1d' : 'transparent', borderRadius: 6, marginBottom: 4,
    textDecoration: 'none', fontSize: 14,
  });

  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 52px)' }}>
      <aside style={{ width: 220, background: '#111827', color: '#fff', padding: 16 }}>
        <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>HUB CONSOLE</div>
        <div style={{ fontWeight: 700, marginBottom: 20 }}>{user.first_name || 'Staff'}</div>
        <NavLink to="/hub/inbox" style={linkStyle}>📥 Inbox</NavLink>
        <NavLink to="/hub/scan-in" style={linkStyle}>🔍 Scan In</NavLink>
        <NavLink to="/hub/dispatch" style={linkStyle}>🚌 Dispatch</NavLink>
        <NavLink to="/hub/walk-in" style={linkStyle}>🏪 Walk-in Booking</NavLink>
        <NavLink to="/hub/cash" style={linkStyle}>💵 Cash Drawer</NavLink>
        <div style={{ marginTop: 40 }}>
          <button className="btn" style={{ background: '#dc2626', color: '#fff', width: '100%' }} onClick={logout}>Logout</button>
        </div>
      </aside>
      <main style={{ flex: 1, padding: 24, background: '#f9fafb' }}>
        <Outlet />
      </main>
    </div>
  );
}
